// import React from "react";

// const Datapower = () => {
//   return (
//     <div style={styles.container}>
//       <div style={styles.rightSide}>
//         <div style={styles.imageContainer}>
//           <img
//             src="/image/data_engineering_img1.png"
//             alt="AI Representation"
//             style={styles.image}
//           />
//         </div>
//       </div>
//       <div style={styles.leftSide}>
//         <h2 style={styles.header}>The Role of Data Engineering and Analytics</h2>
//         <p style={styles.paragraph}>
//           Our data engineering and analytics solutions help businesses make sense of vast amounts of data and provide insights that drive efficiency, growth, and innovation.
//         </p>
//         <ul style={styles.list}>
//           <li style={styles.listItem}>
//             <span style={styles.arrow}>➔</span>Data Integration and ETL
            
//           </li>
//           <li style={styles.listItem}>
//             <span style={styles.arrow}>➔</span> Predictive Analytics and Forecasting
             
//           </li>
//           <li style={styles.listItem}>
//             <span style={styles.arrow}>➔</span> Data Warehousing and Cloud Solutions
             
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "2rem",
//     backgroundColor: "#025261",
//     color: "#fff",
//     flexWrap: "wrap",
//   },
//   leftSide: {
//     flex: 1,
//     paddingRight: "2rem",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//   },
//   header: {
//     fontSize: "2rem",
//     fontWeight: "bold",
//     color: "white",
//   },
//   paragraph: {
//     fontSize: "1rem",
//     margin: "1rem 0",
//     textAlign: "justify",
//   },
//   list: {
//     listStyleType: "none",
//     paddingLeft: 0,
//   },
//   listItem: {
//     fontSize: "1rem",
//     marginBottom: "0.5rem",
//     display: "flex",
//     alignItems: "justify",
//   },
//   arrow: {
//     marginRight: "0.5rem",
//     color: "#4CAF50",
//     fontSize: "1.5rem",
//   },
//   rightSide: {
//     flex: 1,
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     marginTop: "1rem",
//   },
//   imageContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   image: {
//     width: "90%",
//     maxWidth: "500px",
//     height: "auto",
//     borderRadius: "8px",
//   },
// };

// export default Datapower;




import React from "react";

const Datapower = () => {
  return (
    <>
      <style>{`
        .datapower-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 2rem;
          background-color: #025261;
          color: #fff;
          flex-wrap: wrap;
        }

        .datapower-left {
          flex: 1;
          padding-right: 2rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .datapower-header {
          font-size: 2rem;
          font-weight: bold;
          color: white;
        }

        .datapower-paragraph {
          font-size: 1rem;
          margin: 1rem 0;
          text-align: justify;
        }

        .datapower-list {
          list-style-type: none;
          padding-left: 0;
        }

        .datapower-list-item {
          font-size: 1rem;
          margin-bottom: 0.5rem;
          display: flex;
          align-items: center;
        }

        .datapower-arrow {
          margin-right: 0.5rem;
          color: #4CAF50;
          font-size: 1.5rem;
        }

        .datapower-right {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 1rem;
        }

        .datapower-image {
          width: 90%;
          max-width: 500px;
          height: auto;
          border-radius: 8px;
        }

        /* Responsive Styles */
        @media (max-width: 1024px) {
          .datapower-container {
            flex-direction: column;
            text-align: center;
          }
          .datapower-left {
            padding-right: 0;
            margin-bottom: 2rem;
          }
          .datapower-header {
            font-size: 1.8rem;
          }
          .datapower-paragraph,
          .datapower-list-item {
            font-size: 1rem;
          }
        }

        @media (max-width: 768px) {
          .datapower-header {
            font-size: 1.5rem;
          }
          .datapower-paragraph {
            font-size: 0.95rem;
          }
          .datapower-list-item {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 480px) {
          .datapower-container {
            padding: 1rem;
          }
          .datapower-header {
            font-size: 1.3rem;
          }
          .datapower-paragraph {
            font-size: 0.9rem;
          }
          .datapower-list-item {
            font-size: 0.9rem;
          }
          .datapower-image {
            width: 100%;
            max-width: 100%;
          }
        }
      `}</style>

      <div className="datapower-container">
        <div className="datapower-right">
          <div className="datapower-image-container">
            <img
              src="/image/data_engineering_img1.png"
              alt="AI Representation"
              className="datapower-image"
            />
          </div>
        </div>

        <div className="datapower-left">
          <h2 className="datapower-header">
            The Role of Data Engineering and Analytics
          </h2>
          <p className="datapower-paragraph">
            Our data engineering and analytics solutions help businesses make
            sense of vast amounts of data and provide insights that drive
            efficiency, growth, and innovation.
          </p>
          <ul className="datapower-list">
            <li className="datapower-list-item">
              <span className="datapower-arrow">➔</span> Data Integration and ETL
            </li>
            <li className="datapower-list-item">
              <span className="datapower-arrow">➔</span> Predictive Analytics and Forecasting
            </li>
            <li className="datapower-list-item">
              <span className="datapower-arrow">➔</span> Data Warehousing and Cloud Solutions
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Datapower;
